/**
 * Map anchors traced on the final artwork (public/map/map.jpg)
 *
 * Anchors retraced on the final map artwork (map.jpg, 1619x971) in this
 * repo's existing normalised 0..1000 x 0..600 space. Mile values kept
 * exactly as the current file (incl. Tom Bombadil, Saruman-on-the-road and
 * the 1809 post-eagle Minas Tirith). Nodes with mile: null shape the drawn
 * path only. To convert to map.jpg pixels: px.x = x * 1.619, px.y = y * 1.6183.
 */
export interface PathNode {
  x: number;
  y: number;
  mile: number | null;
}

export const PATH: PathNode[] = [
  { x: 222, y: 228, mile: 0 },      // Bag End
  { x: 256, y: 230, mile: 73 },     // Crickhollow (Bucklebury Ferry at ~70)
  { x: 280, y: 236, mile: 98 },     // Tom Bombadil (Old Forest, south of road)
  { x: 313, y: 234, mile: 135 },    // Bree
  { x: 348, y: 207, mile: null },   // road bends NE toward the downs
  { x: 381, y: 178, mile: 240 },    // Weathertop (ruined tower art)
  { x: 415, y: 116, mile: 358 },    // Last Bridge
  { x: 439, y: 113, mile: null },   // Ford of Bruinen (mile 450 lands here)
  { x: 469, y: 120, mile: 458 },    // Rivendell (west foothills)
  { x: 468, y: 132, mile: null },
  { x: 461, y: 144, mile: 688 },    // Hollin
  { x: 487, y: 153, mile: 748 },    // Caradhras (high peaks)
  { x: 472, y: 163, mile: 818 },    // Doors of Moria (west flank)
  { x: 505, y: 168, mile: 860 },    // Dimrill Dale (east flank)
  { x: 538, y: 186, mile: 920 },    // Caras Galadhon (golden wood art)
  { x: 573, y: 227, mile: null },   // Anduin
  { x: 592, y: 267, mile: 1250 },   // Sarn Gebir
  { x: 649, y: 335, mile: 1309 },   // Parth Galen / Rauros (waterfall art)
  { x: 681, y: 351, mile: 1344 },   // Emyn Muil
  { x: 759, y: 366, mile: 1379 },   // Dead Marshes (marsh art)
  { x: 810, y: 424, mile: 1459 },   // Black Gate (gate art in Mordor's NW wall)
  { x: 675, y: 401, mile: 1534 },   // Henneth Annûn (back west, Ithilien)
  { x: 743, y: 474, mile: 1609 },   // Minas Morgul
  { x: 759, y: 476, mile: 1654 },   // Cirith Ungol
  { x: 819, y: 453, mile: 1729 },   // Isenmouthe
  { x: 893, y: 444, mile: 1779 },   // Mount Doom (volcano art)
  { x: 668, y: 481, mile: 1809 },   // Minas Tirith (white city art; post-eagle)
  { x: 563, y: 429, mile: 2029 },   // Edoras
  { x: 528, y: 432, mile: 2179 },   // Helm's Deep (NW tip of White Mtns)
  { x: 499, y: 336, mile: 2314 },   // Isengard (black tower art)
  { x: 451, y: 344, mile: 2434 },   // Saruman on the road
  { x: 347, y: 360, mile: 2694 },   // Tharbad
  { x: 406, y: 258, mile: null },   // Eregion shaping point
  { x: 469, y: 120, mile: 3007 },   // Rivendell again
  { x: 313, y: 234, mile: 3330 },   // Bree again
  { x: 222, y: 228, mile: 3404 },   // Bag End again
  { x: 145, y: 223, mile: 3637 },   // Grey Havens (harbor town art)
  { x: 222, y: 228, mile: 3871 },   // Bag End, "Well, I'm back."
];
